import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "reInspect",
  "use": "reInspect-usage",
  "viewBox": "0 0 49.44 59.7",
  "content": "<symbol viewBox=\"0 0 49.44 59.7\" id=\"reInspect\"><title>资源 24</title><g id=\"reInspect_图层_2\" data-name=\"图层 2\"><g id=\"reInspect_图层_1-2\" data-name=\"图层 1\"><path d=\"M24.72,59.7C15.86,59.7,0,46.6,0,33.71V8.51l4.34-.05A30.14,30.14,0,0,0,13.8,6.38,42.65,42.65,0,0,0,22.05,2l2.63-2,2.57,1.87.11.07a46.62,46.62,0,0,0,8.26,4.44,29.87,29.87,0,0,0,9.47,2.07l4.29.05.06,25.2C49.44,46.6,33.58,59.7,24.72,59.7ZM4.2,12.66V33.71C4.2,44,17.59,55.5,24.72,55.5S45.24,44,45.24,33.71l-.05-21.06H45a34.1,34.1,0,0,1-11-2.39A51.45,51.45,0,0,1,25.41,5.7h0l-.66-.48-.09.06h0a46.33,46.33,0,0,1-9.22,5,34.06,34.06,0,0,1-11,2.39Z\" /><rect x=\"22.72\" y=\"18.35\" width=\"4\" height=\"23\" rx=\"2\" ry=\"2\" /><rect x=\"22.72\" y=\"20.35\" width=\"4\" height=\"19\" rx=\"2\" ry=\"2\" transform=\"translate(54.57 5.13) rotate(90)\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/reInspect.svg
// module id = CDyZ
// module chunks = 264